<div class="delete-reason-page">
  <div class="delete-reason-page__close" (click)="close()">
    <i class="fsi fsi-close"></i>
  </div>

  <div class="delete-reason-page__icon">
    <i class="fsi fsi-circle-check-on"></i>
  </div>

  <div class="delete-reason-page__title">Заявка отравлена</div>

  <div class="delete-reason-page__list">
    Для завершения оформления перейдите по ссылке, отправленной в Viber или по
    смс на ваш телефон
  </div>

  <div class="delete-reason-page__actions">
    <button matRipple class="btn btn-secondary" (click)="close()">
      Понятно
    </button>
  </div>
</div>
